let elements = [
  //////////////
  // 1
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#df0024',
        3: '#05a6e2',
        4: '#05a6e2',
        5: '#f2ea00',
        6: '#df0024',
        7: '#df0024',
        8: '#f2ea00',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 231,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 509,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 787,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
  //////////////
  // 2
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t2.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#f2ea00',
        3: '#05a6e2',
        4: '#05a6e2',
        5: '#df0024',
        6: '#f2ea00',
        7: '#f2ea00',
        8: '#df0024',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 231,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 509,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            // y: 787,
            // x: 1796,
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
  //////////////
  // 3
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t3.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#f2ea00',
        3: '#df0024',
        4: '#df0024',
        5: '#05a6e2',
        6: '#f2ea00',
        7: '#f2ea00',
        8: '#05a6e2',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
  //////////////
  // 4
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t4.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#df0024',
        3: '#f2ea00',
        4: '#f2ea00',
        5: '#05a6e2',
        6: '#df0024',
        7: '#df0024',
        8: '#05a6e2',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
  //////////////
  // 5
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t5.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#05a6e2',
        3: '#f2ea00',
        4: '#f2ea00',
        5: '#df0024',
        6: '#05a6e2',
        7: '#05a6e2',
        8: '#df0024',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-103px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
  //////////////
  // 6
  //////////////
  {
    blockCheck: true,
    blockWrongColor: true,
    audio: {
      negative: 'games/page052_game0/audio/false.mp3',
      // positive: 'games/page052_game0/audio/true.mp3',
      click: 'games/page052_game0/audio/click.mp3',
    },
    image: {
      trImage: 'games/page052_game0/img/img_t6.webp',
      srcImage: 'games/page052_game0/img/img_o.png',
      srcMask: 'games/page052_game0/img/img_m.png',
      width: 1920,
      height: 1080,
      colors: {
        1: '#000000',
        2: '#05a6e2',
        3: '#df0024',
        4: '#df0024',
        5: '#f2ea00',
        6: '#05a6e2',
        7: '#05a6e2',
        8: '#f2ea00',
      },
      cssStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: '1080px',
        width: '1920px',
      },
    },
    palette: {
      colors: [
        {
          audioId: 'a1',
          val: '#05a6e2',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
          clicked: { src: 'games/page033_game1/img/blue_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '17.1%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(5,166,226,0.4)',
          },
        },
        {
          audioId: 'a2',
          val: '#df0024',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
          clicked: { src: 'games/page033_game1/img/red_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '42.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(255,105,192,0.4)',
          },
        },
        {
          audioId: 'a3',
          val: '#f2ea00',
          audio: 'games/page052_game0/audio/true.mp3',
          waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
          clicked: { src: 'games/page033_game1/img/yellow_p.png' },
          cssStyle: {
            position: 'absolute',
            left: '71.7%',
            top: '68.6%',
            width: '7.3%',
            height: '13%',
            transform: 'rotate(0deg)',
            'border-radius': '50%',
            // 'background-color': 'rgba(242,234,0,0.4)',
          },
        },
      ],
      mbPaletteAudioItemData: [
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a1',
          src: 'games/page052_game0/audio/72_baubles.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a2',
          src: 'games/page052_game0/audio/74_stars.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
        {
          maskConfig: {
            click: { src: 'games/page052_game0/audio/click.mp3' },
            src: 'games/page052_game0/img/folia.png',
            cssStyle: {
              'margin-left': '-284px',
              'margin-top': '-102px',
            },
          },
          id: 'a3',
          src: 'games/page052_game0/audio/73_bells.mp3',
          audioConfig: {
            autoplay: false,
            loop: false,
            volume: 1,
          },
          iconConfig: {
            src: { iconOn: 'games/page052_game0/img/audioOn.png', iconOff: 'games/page052_game0/img/audioOff.png' },
            fill: 'none',
          },
          width: '48px',
          height: '48px',
          pos: {
            y: 46,
            x: 419,
          },
          unit: 'px',
        },
      ],
    },
  },
];

export default { ...elements, blockCheck: true };
